const DoneIcon = () => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.2566 6.17041H12.3145C12.1095 6.17041 11.9147 6.26885 11.7941 6.4376L8.6361 10.8171L7.20574 8.83224C7.08521 8.6655 6.89235 8.56505 6.68543 8.56505H5.74324C5.61266 8.56505 5.53632 8.71371 5.61266 8.82019L8.11579 12.2916C8.17492 12.3741 8.25288 12.4414 8.34319 12.4878C8.4335 12.5342 8.53357 12.5584 8.6351 12.5584C8.73663 12.5584 8.8367 12.5342 8.92701 12.4878C9.01732 12.4414 9.09527 12.3741 9.15441 12.2916L13.3852 6.42554C13.4636 6.31907 13.3872 6.17041 13.2566 6.17041Z"
        fill="#67BF59"
      />
      <path
        d="M9.5 0.365234C4.52991 0.365234 0.5 4.39515 0.5 9.36523C0.5 14.3353 4.52991 18.3652 9.5 18.3652C14.4701 18.3652 18.5 14.3353 18.5 9.36523C18.5 4.39515 14.4701 0.365234 9.5 0.365234ZM9.5 16.8384C5.37366 16.8384 2.02679 13.4916 2.02679 9.36523C2.02679 5.2389 5.37366 1.89202 9.5 1.89202C13.6263 1.89202 16.9732 5.2389 16.9732 9.36523C16.9732 13.4916 13.6263 16.8384 9.5 16.8384Z"
        fill="#67BF59"
      />
    </svg>
  );
};

export default DoneIcon;
